export const reviewsPageTypes = {
    'Self-Storage': [
        {
            reviewTitle: 'SpareFoot made it easy...',
            reviewRating: 5,
            reviewText: 'SpareFoot has so many choices, but they make it easy to navigate through them.',
            reviewerInitials: 'BJ',
            reviewerName: 'Bill Jeffrey'
        },
        {
            reviewTitle: 'Online Reservations...',
            reviewRating: 5,
            reviewText: 'Renting a space from Sparefoot could not have been any easier! Online reservations was a "walk in the park", with every detail mapped out for you...',
            reviewerInitials: 'LP',
            reviewerName: 'Larry Powell'
        },
        {
            reviewTitle: 'Easy to Reserve!',
            reviewRating: 5,
            reviewText: "Kevin at SpareFoot was super helpful in helping me find a storage unit in the state I'm moving to (Wisconsin). Easy to reserve and clear on pricing!",
            reviewerInitials: 'JH',
            reviewerName: 'Jane H'
        },
        {
            reviewTitle: 'Pleasant',
            reviewRating: 4,
            reviewText: 'I liked my experience with Sparefoot bc I was able to gather all of my information the facility, unit, location, and price without being harrassed by a pushy sales person',
            reviewerInitials: 'ML',
            reviewerName: 'Mary Jeanne Love'
        },
    ],
    'Boat': [
        {
            reviewTitle: 'I am pleased with my experience',
            reviewRating: 5,
            reviewText: 'I am pleased with my experience. The man who helped me on the phone was polite.and knowledgeable. I was having difficulty finding a boat slip, and I recommend them to anybody looking for boat space.',
            reviewerInitials: 'KF',
            reviewerName: 'kimberly Forbes'
        },
        {
            reviewTitle: 'Online shopping was a breeze',
            reviewRating: 5,
            reviewText: "I thought the web site was easy to use, and I'm not real tech savvy. I found a place to store my boat quickly, and the monthly price was very competitive. I also took advantage of the internet discount, too, making the value even better. And the people at Water Street Storage helped seal the deal!",
            reviewerInitials: 'ST',
            reviewerName: 'Steve'
        },
        {
            reviewTitle: 'HELPFUL!',
            reviewRating: 5,
            reviewText: "I was looking for outdoor storage for my boat, and they narrowed down a great spot close to my residence in minutes. Very polite to deal with.",
            reviewerInitials: 'KW',
            reviewerName: 'Kevin H. Whittemore'
        },
        {
            reviewTitle: 'Reasonable price',
            reviewRating: 4,
            reviewText: 'They have multiple storage options (also boat, RV, and car parking) with a reasonable price.',
            reviewerInitials: 'HJ',
            reviewerName: 'HJ'
        },
    ],
    'Car': [
        {
            reviewTitle: 'Very helpful clear explanation…',
            reviewRating: 5,
            reviewText: 'Very helpful clear explanation &recommendations for 1st time renter for car storage.',
            reviewerInitials: 'WI',
            reviewerName: 'Will'
        },
        {
            reviewTitle: 'Helped to find exactly what I was…',
            reviewRating: 4,
            reviewText: 'Helped to find exactly what I was looking for in a storage place for our older car.',
            reviewerInitials: 'EH',
            reviewerName: 'Eddie H.'
        },
        {
            reviewTitle: 'Super easy and relaxing experience!',
            reviewRating: 5,
            reviewText: 'It was easy to find a location I needed and once I sent my request the gal called me that evening and was super friendly. Ive been stressed about finding a place to store my car between visits and this experience made it so easy and now I can relax!',
            reviewerInitials: 'MP',
            reviewerName: 'Marcia Pierce-rasmussen'
        },
        {
            reviewTitle: 'Great place to get prices and…',
            reviewRating: 4,
            reviewText: 'Great place to get prices and availability in the area you need storage. Be sure to check though as I’ve mentioned needing to store a car in the initial place did not have room to make the turn if you have a larger vehicle . Always check with the storage company directly if you have specific needs.',
            reviewerInitials: 'SR',
            reviewerName: 'Sharon Ramsey'
        },
    ],
    'RV': [
        {
            reviewTitle: 'Very professional and helpful',
            reviewRating: 5,
            reviewText: 'The gentleman went out of his way to try and find us a space for our RV on a Sunday. He was so nice.',
            reviewerInitials: 'KB',
            reviewerName: 'Kelly Barry'
        },
        {
            reviewTitle: 'Easy to use',
            reviewRating: 5,
            reviewText: 'The site is easy to use and I was able to find a storage location close to home. The location allowed us to view the space before committing to a lease. Our space is perfectly level. SpareFoot is definitely an easy way to select an RV storage spot.',
            reviewerInitials: 'HW',
            reviewerName: 'Harry Wind'
        },
        {
            reviewTitle: 'Great helpful tool',
            reviewRating: 5,
            reviewText: 'This is a great tool that helps me find the nearby RV/travel trailer storage places with promotional offers. Love it!',
            reviewerInitials: 'HA',
            reviewerName: 'Hans'
        },
        {
            reviewTitle: 'Easy as Dinner Reservations',
            reviewRating: 4,
            reviewText: 'Finding a place to store my RV was difficult until I came across SpareFoot. It was as easy as making dinner reservations.',
            reviewerInitials: 'AN',
            reviewerName: 'Adam N'
        },
    ],
    'Trailer': [
        {
            reviewTitle: 'Easy & fast',
            reviewRating: 5,
            reviewText: 'The storage I was in gave me a 10 day notice that they were shutting down. I made 1 call and had a space to have my trailer moved to.',
            reviewerInitials: 'MM',
            reviewerName: 'Mark Morningstar'
        },
        {
            reviewTitle: 'Great helpful tool',
            reviewRating: 5,
            reviewText: 'This is a great tool that helps me find the nearby RV/travel trailer storage places with promotional offers. Love it!',
            reviewerInitials: 'HA',
            reviewerName: 'Hans'
        },
        {
            reviewTitle: 'Great assistance',
            reviewRating: 5,
            reviewText: 'Mario was the gentleman who helped me secure a spot for our trailer. He was knowledgeable, polite and easy to work with. I would definitely go through SpareFoot again.',
            reviewerInitials: 'MY',
            reviewerName: 'Myra'
        },
        {
            reviewTitle: 'Good Source to Use',
            reviewRating: 4,
            reviewText: 'A very good source to be used for all your storage needs, I needed to park a Trailer and they were so helpful in finding best place, near to my house and at the most economical price',
            reviewerInitials: 'NA',
            reviewerName: 'Namita'
        },
    ]
}